var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutDefault',[_c('div',{staticClass:"text-center empty d-flex flex-column w-75 m-auto"},[_c('h4',{staticClass:"m-5"},[_vm._v("Access Denied")]),_c('img',{attrs:{"src":"static/img/undraw_access_denied.svg"}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }